import { render } from "./Employee.vue?vue&type=template&id=6971a36e&scoped=true&ts=true"
import script from "./Employee.vue?vue&type=script&lang=ts"
export * from "./Employee.vue?vue&type=script&lang=ts"

import "./Employee.vue?vue&type=style&index=0&id=6971a36e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6971a36e"]])

export default __exports__